'use client';

import { Indicator, Root } from '@radix-ui/react-progress';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Progress({
  value,
  className,
  ...props
}: ComponentProps<typeof Root>): JSX.Element {
  return (
    <Root
      data-slot='progress'
      className={cn(
        'bg-[#f2f3f5] relative h-2.5 w-full overflow-hidden rounded-[100px]',
        className,
      )}
      {...props}
    >
      <Indicator
        data-slot='progress-indicator'
        className='bg-blueBonnet-500 h-full w-full flex-1 transition-all'
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
        }}
      />
    </Root>
  );
}
